import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=406bd40a&scoped=true"
import script from "./course-detail.vue?vue&type=script&lang=js"
export * from "./course-detail.vue?vue&type=script&lang=js"
import style0 from "./course-detail.vue?vue&type=style&index=0&id=406bd40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406bd40a",
  null
  
)

export default component.exports